import React from "react";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import SearchHistoryListing from "./SearchHistoryListing";

type Props = {};

const SearchHistoryListingWrapper = (props: Props) => {
  return (
    <SideNavLayout>
     <SearchHistoryListing/>
    </SideNavLayout>
  );
};

export default SearchHistoryListingWrapper;
